import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppState } from 'customHooks/useAppState';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import IframeResizer from 'iframe-resizer-react';

interface EmailPreviewProps {
    messageId: string | number;
    autoSaving: boolean;
}

const EmailPreview = (props: EmailPreviewProps) => {
    const { messageId, autoSaving } = props;
    const { accountId } = useCurrentAccount();
    const { apiUrl } = useAppState();

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            {autoSaving && (
                <FontAwesomeIcon icon={faSpinnerThird} style={{ fontSize: '25px' }} spin />
            )}
            {!autoSaving && (
                <IframeResizer
                    frameBorder="0"
                    autoResize={false}
                    style={{
                        width: '100%',
                        borderBottomLeftRadius: '16px',
                        borderBottomRightRadius: '16px',
                    }}
                    src={`${apiUrl}/dashboard/accounts/${accountId}/messages/${messageId}/preview`}
                />
            )}
        </div>
    );
};

export default EmailPreview;
